import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  cards: {
    height: 'auto',
    [theme.breakpoints.down('sm')]: {
      borderRadius: 16,
      padding: 16,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
  },
}))
